import { TransformInt } from '../../../decorators/transform-int.decorator';

import { CreateVehicleMakeDto } from './create-vehicle-make.dto';

/**
 * Update vehicle make DTO
 */
export class UpdateVehicleMakeDto extends CreateVehicleMakeDto {
	@TransformInt()
	id!: number;
}
